<template>
    <div class="ckeditor">
        <textarea :id="id" :value="value"></textarea>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        props: {
            value: {
                type: String
            },
            id: {
                type: String,
                default: 'editor',
                required: true
            },
            height: {
                type: String,
                default: '200px',
            },
            toolbar: {
                default: () => [
                    {name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates']},
                    {name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', 'Undo', 'Redo']},
                    {name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt']},
                    {
                        name: 'forms',
                        items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField']
                    },
                    '/',
                    {
                        name: 'basicstyles',
                        items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat']
                    },
                    {
                        name: 'paragraph',
                        items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language']
                    },
                    {name: 'links', items: ['Link', 'Unlink', 'Anchor']},
                    {
                        name: 'insert',
                        items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe']
                    },
                    '/',
                    {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']},
                    {name: 'colors', items: ['TextColor', 'BGColor']},
                    {name: 'tools', items: ['Maximize', 'ShowBlocks']},
                    {name: 'about', items: ['About']}
                ]
            },
            font_names: {
                type: String,
                default: ''
            },
            language: {
                type: String,
                default: 'en'
            },
            allowedContent: {
                type: Boolean,
                default: true
            },
            filebrowserUploadUrl: {
                type: String,
                default: ''
            },
            jsplusUploaderUrl: {
                type: String,
                default: ''
            },
            extraplugins: {
                type: String,
                default: ''
            },
            removeButtons: {
                type: String,
                default: ''
            }
        },
        beforeUpdate() {
            const ckeditorId = this.id
            if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
                CKEDITOR.instances[ckeditorId].setData(this.value)
            }
        },
        mounted() {
            const ckeditorId = this.id
            const ckeditorConfig = {
                allowedContent: this.allowedContent,
                font_names: this.font_names,
                toolbar: this.toolbar,
                language: this.language,
                height: this.height,
                extraPlugins: this.extraplugins,
                uploadUrl: this.filebrowserUploadUrl,
                jsplus_uploader_url: this.jsplusUploaderUrl,
                removeButtons: this.removeButtons,
                enterMode: CKEDITOR.ENTER_BR,
                shiftEnterMode: CKEDITOR.ENTER_P,
            }
            CKEDITOR.replace(ckeditorId, ckeditorConfig)
            CKEDITOR.instances[ckeditorId].setData(this.value)
            CKEDITOR.instances[ckeditorId].on('change', () => {
                let ckeditorData = CKEDITOR.instances[ckeditorId].getData()
                if (ckeditorData !== this.value) {
                    this.$emit('input', ckeditorData)
                }
            })
        },
        destroyed() {
            const ckeditorId = this.id
            if (CKEDITOR.instances[ckeditorId]) {
                CKEDITOR.instances[ckeditorId].destroy()
            }
        }
    }
    /* eslint-enable */
</script>

<style>
    .ckeditor::after {
        content: "";
        display: table;
        clear: both;
    }
</style>
